module.exports = __webpack_public_path__ + "img/author_img.207ccce2.png";